<div *ngIf="cs.isBrowser" [formGroup]="form" class="form-group">
  <label>{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <ng-multiselect-dropdown
    #dropdownMultiSelect
    [placeholder]="field.placeholder"
    [settings]="field.settings"
    [data]="field.options"
    (onFilterChange)="onSearchChange($event)"
    formControlName="{{ field.name }}"
    (onSelect)="onItemSelect()"
    (onDropDownClose)="dropdownMultiSelect.filter.text = ''; closeDropdown()"
  ></ng-multiselect-dropdown>

  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
